// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3uqT9","content":"LayoutSettings_content__38j2H"};